import * as _ from 'underscore'

import { OpOperatorGroup, OpOperator, OpTechnicalPermission } from '../../models/core'
import { Enums } from '../../models/common'

import { OPERATOR_GROUP_SERVICE_NAME, OperatorGroupService } from './operator-group.service'
import { GridService, GRID_SERVICE_NAME } from '../grid'

//#region Public Types

export const OPERATOR_GROUP_OPERATORS_SERVICE_NAME = 'OperatorGroupOperatorsService'
export const OPERATOR_GROUP_OPERATORS_SERVICE_PROVIDER_NAME = 'OperatorGroupOperatorsServiceProvider'

//#endregion

export class OperatorGroupOperatorsService {

    // #region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.OperatorGroup.Operators]' }

    // #endregion


    //#region Ctor

    constructor(private gridService: GridService, private operatorGroupService: OperatorGroupService) { }

    //#endregion


    //#region Save

    public saveOperatorsToOperatorGroup(operatorGroup: OpOperatorGroup, addedOperators: OpOperator[], removedOperators: OpOperator[]): JQueryPromise<OpOperatorGroup> {
        const operatorGroupToSave: OpOperatorGroup = new OpOperatorGroup(null)

        operatorGroupToSave.idOperatorGroup = operatorGroup.idOperatorGroup
        operatorGroupToSave.opState = Enums.OpChangeState.Modified
        operatorGroupToSave.technicalPermissions = _.map(operatorGroup.technicalPermissions, (technicalPermission: OpTechnicalPermission) => technicalPermission.clone())
        operatorGroupToSave.currentOperators = []

        _.forEach(addedOperators, (addedOperator: OpOperator) => {
            const clonedOperator: OpOperator = addedOperator.clone()

            clonedOperator.opState = Enums.OpChangeState.New

            operatorGroupToSave.currentOperators.push(clonedOperator)
        })

        _.forEach(removedOperators, (removedOperator: OpOperator) => {
            const clonedOperator: OpOperator = removedOperator.clone()

            clonedOperator.opState = Enums.OpChangeState.Delete

            operatorGroupToSave.currentOperators.push(clonedOperator)
        })

        const removedOperatorIds: number[] = removedOperators.map((removedOperator: OpOperator) => removedOperator.idOperator)

        operatorGroup.currentOperators
            .filter((loadedOperatorGroup: OpOperator) => !_.include(removedOperatorIds, loadedOperatorGroup.idOperator))
            .forEach((loadedOperatorGroup: OpOperator) => {
                const clonedOperator = loadedOperatorGroup.clone()

                clonedOperator.opState = Enums.OpChangeState.Loaded

                operatorGroupToSave.currentOperators.push(clonedOperator)
            })

        return this.operatorGroupService.saveOperatorGroup(operatorGroupToSave)
    }

    public saveOperatorsGridEditResult(operatorGroup: OpOperatorGroup, addedGridItems: any[], removedGridItems: any[], grid: any): JQueryPromise<OpOperatorGroup> {
        const addedOperators: OpOperator[] = []
        const removedOperators: OpOperator[] = []

        _.forEach(grid, (gridItem: any) => {
            if (gridItem.isNew) {
                const operator: OpOperator = new OpOperator(null)

                operator.idOperator = gridItem.id

                addedOperators.push(operator)
            }
        })

        _.forEach(grid, (gridItem: any) => {
            if (gridItem.isRemoved) {
                const operator: OpOperator = new OpOperator(null)

                operator.idOperator = gridItem.id

                removedOperators.push(operator)
            }
        })


        return this.saveOperatorsToOperatorGroup(operatorGroup, addedOperators, removedOperators)
    }

    //#endregion
}

export class OperatorGroupOperatorsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [GRID_SERVICE_NAME, OPERATOR_GROUP_SERVICE_NAME, function (gridService: GridService, operatorGroupService: OperatorGroupService) {
        return new OperatorGroupOperatorsService(gridService, operatorGroupService)
    }]

    //#endregion
} 